import { jsPDF } from "jspdf";
import QRCode from "qrcode";
import { Staff } from "./types";

export function generateEmpCode(lastNumber: number): string {
  return `STF-${String(lastNumber + 1).padStart(4, "0")}`;
}

export async function generateStaffIdCard(staff: Staff): Promise<void> {
  const doc = new jsPDF("p", "pt", [336, 212]); // ID card size (credit card dimensions)
  
  try {
    const qrDataUrl = await QRCode.toDataURL(`${window.location.origin}/staff/${staff.id}`);

    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 336, 212, 'F');

    doc.setFillColor(59, 130, 246); // blue-600
    doc.rect(0, 0, 336, 40, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("MedSystem Hospital", 20, 25);

    doc.setFillColor(229, 231, 235); // gray-200
    doc.rect(20, 50, 80, 80, 'F');
    
    if (staff.photoUrl) {
      try {
        doc.addImage(staff.photoUrl, "JPEG", 20, 50, 80, 80);
      } catch (error) {
        doc.setTextColor(107, 114, 128); // gray-500
        doc.setFontSize(8);
        doc.text("Photo", 55, 95);
      }
    } else {
      doc.setTextColor(107, 114, 128); // gray-500
      doc.setFontSize(8);
      doc.text("Photo", 55, 95);
    }

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(staff.name, 120, 70);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Role: ${staff.role.charAt(0).toUpperCase() + staff.role.slice(1)}`, 120, 85);
    doc.text(`Dept: ${staff.department || "N/A"}`, 120, 100);
    doc.text(`Code: ${staff.empCode}`, 120, 115);
    doc.text(`Blood: ${staff.bloodGroup || "N/A"}`, 120, 130);

    doc.addImage(qrDataUrl, "PNG", 240, 50, 80, 80);

    doc.setFillColor(243, 244, 246); // gray-100
    doc.rect(0, 172, 336, 40, 'F');
    
    doc.setTextColor(75, 85, 99); // gray-600
    doc.setFontSize(8);
    doc.text("Authorized Personnel Only", 20, 190);
    doc.text(`Issued: ${new Date().toLocaleDateString()}`, 20, 200);

    doc.save(`ID_${staff.empCode}_${staff.name.replace(/\s+/g, '_')}.pdf`);
  } catch (error) {
    console.error('Error generating ID card:', error);
    throw new Error('Failed to generate ID card');
  }
}

export function getRoleDisplayName(role: string): string {
  const roleMap: Record<string, string> = {
    doctor: "Doctor",
    nurse: "Nurse",
    pharmacist: "Pharmacist",
    lab_tech: "Lab Technician",
    reception: "Reception",
    billing: "Billing Staff",
    cleaner: "Cleaner",
    security: "Security",
    admin: "Administrator",
    other: "Other"
  };
  return roleMap[role] || role;
}

export function getStatusColor(status: string): string {
  const statusColors: Record<string, string> = {
    active: "bg-green-100 text-green-800",
    inactive: "bg-yellow-100 text-yellow-800",
    resigned: "bg-gray-100 text-gray-800",
    terminated: "bg-red-100 text-red-800"
  };
  return statusColors[status] || "bg-gray-100 text-gray-800";
}
